import React from "react";
import ServiceHeader from "../../component/ServiceHeader";
import "../../views/PageContent.css";
import { useNavigate } from "react-router-dom";

const DictationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ width: 48, height: 48, color: '#2563eb' }}>
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" x2="12" y1="19" y2="22" />
  </svg>
);

const AssistantIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ width: 48, height: 48, color: '#9333ea' }}>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="10" r="3" />
    <path d="M12 13v4" />
  </svg>
);

const UploadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ width: 48, height: 48, color: '#f59e0b' }}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const ForecastIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ width: 48, height: 48, color: '#16a34a' }}>
    <path d="M3 3v18h18" />
    <path d="M9 17l3-3 4 4 5-7" />
  </svg>
);

const FileSearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ width: 48, height: 48, color: '#0ea5e9' }}>
    <path d="M21 21l-4.35-4.35" />
    <circle cx="11" cy="11" r="8" />
  </svg>
);

const useCases = [
  {
    icon: <DictationIcon />,
    title: "Dictation Conversion",
    description: "No typing needed; dictate repair details.",
    details: [
      "Start from pending ticket",
      "Speak your process",
      "AI transcribes and updates logs"
    ]
  },
  {
    icon: <AssistantIcon />,
    title: "Repair Assistant",
    description: "AI helps suggest solutions from historical data.",
    details: [
      "Auto-match issues with past fixes",
      "Contact details of resolver",
      "Improve with feedback loop"
    ]
  },
  {
    icon: <UploadIcon />,
    title: "Grid Image Analysis",
    description: "Optimize electrical grid using AI pattern recognition.",
    details: [
      "Upload visual plan",
      "AI suggests load balancing",
      "Adds redundancy, transformer placement"
    ]
  },
  {
    icon: <ForecastIcon />,
    title: "Energy Forecasting",
    description: "Predict future energy consumption using ML.",
    details: [
      "Train model on past data",
      "Incorporates weather conditions",
      "Helps plan infrastructure"
    ]
  },
  {
    icon: <FileSearchIcon />,
    title: "File Search (RAG)",
    description: "Ask questions, get answers from your PDFs.",
    details: [
      "Uses RAG model",
      "Searches internal file base",
      "Instant answers from knowledge docs"
    ]
  }
];

const Utility = () => {
  const navigate = useNavigate();
  return (
    <div className="wrapper">
      {<ServiceHeader title="AI-Powered Utility Solutions" />}
      <section style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f9fafb'
      }}>
        <section style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '4rem 1.5rem'
        }}>
          <h2 style={{
            fontSize: '1.875rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '3rem'
          }}>
            Our Smart Utility Use Cases
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(250px, 1fr))',
            gap: '1.5rem'
          }}>
             {useCases.map((useCase, index) => (
              <div key={index} style={{
                backgroundColor: 'white',
                padding: '1.5rem',
                borderRadius: '0.5rem',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-6px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                  {useCase.icon}
                  <h3 style={{ marginLeft: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>
                    {useCase.title}
                  </h3>
                </div>
                <p style={{ color: '#4b5563', marginBottom: '1rem' }}>{useCase.description}</p>
                <div style={{ marginTop: '1rem' }}>
                  {useCase.details.map((detail, detailIndex) => (
                    <div key={detailIndex} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                      <span style={{ color: '#10b981', marginRight: '0.5rem' }}>✓</span>
                      <span>{detail}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
        <section
  style={{
    maxWidth: '1200px',
    margin: '3rem auto',
    padding: '0 1.5rem',
  }}
>
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(280px, 1fr))',
      gap: '10rem',
    }}
  >
    <div
      style={{
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none"
          viewBox="0 0 24 24" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 3v18l15-9L5 3z" />
        </svg>
        <h3 style={{ marginLeft: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>Launch Utility App - Eversource</h3>
      </div>
      <p style={{ color: '#4b5563', marginBottom: '1rem' }}>
        Access our full-featured utility AI platform.
      </p>
      <button
        onClick={() => window.open("https://utility.sstglobal.net/", "_blank")}
        style={{
          backgroundColor: '#2563eb',
          color: 'white',
          padding: '0.5rem 1.5rem',
          borderRadius: '0.375rem',
          fontWeight: '600',
          fontSize: '0.95rem',
          border: 'none',
          cursor: 'pointer',
          alignSelf: 'start'
        }}
      >
        Launch Now
      </button>
    </div>
    <div
      style={{
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none"
          viewBox="0 0 24 24" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <line x1="10" y1="9" x2="9" y2="9" />
        </svg>
        <h3 style={{ marginLeft: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>Download Utility Deck</h3>
      </div>
      <p style={{ color: '#4b5563', marginBottom: '1rem' }}>
        Access the PDF for complete overview of Utility AI.
      </p>
      <a
        href="https://stlangutilitydev.blob.core.windows.net/uploadfiles/Utility-deck.pdf"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#7c3aed',
          color: 'white',
          padding: '0.5rem 1.5rem',
          borderRadius: '0.375rem',
          fontWeight: '600',
          fontSize: '0.95rem',
          textDecoration: 'none',
          alignSelf: 'start'
        }}
      >
        Download PDF
      </a>
    </div>
  </div>
</section>

        
      </section>
    </div>
  );
};

export default Utility;
